function ContactUs() {

  return (
    <section className="container py-5">
      <div className="row justify-content-center">
        <div className="col-12 text-center mb-4">
          <h2 className="t-primary fw-semibold">تواصل معنا</h2>
          <p>
            نحن هنا لمساعدتك! لا تتردد في الاتصال بنا لأي استفسارات أو أسئلة.
          </p>
        </div>
        <div className="col-md-4 mt-5 mt-md-0">
          <div className="card border-0 shadow-sm">
            <div className="card-body text-center">
              <h5 className="card-title t-primary">معلومات الاتصال</h5>
              <p className="mb-2">
              ebdaa5623@gmail.com
                <i className="bi bi-envelope me-2"></i> 
              </p>
              <p className=" mb-2">
              1001058518 20+ <i className="bi bi-telephone me-2"></i>  
              </p>
              <p className=" mb-2">
              1288375218 20+ <i className="bi bi-telephone me-2"></i> 
              </p>
              <p className=" mb-2">
              القاهرة، مصر
                <i className="bi bi-geo-alt me-2"></i> 
              </p>
              <div className="d-flex justify-content-center gap-3 mt-3">
                <a
                  href="https://www.facebook.com/profile.php?id=61560319727519&mibextid=ZbWKwL"
                  target="_blank"
                  rel="noreferrer"
                  className="t-primary"
                >
                  <i className="bi bi-facebook fs-4"></i>
                </a>
                <a
                  href="https://wa.me/+201001058518"
                  target="_blank"
                  rel="noreferrer"
                  className="t-primary"
                >
                  <i className="bi bi-whatsapp fs-4"></i>
                </a>
                <a
                  href="https://www.instagram.com/ebdaa_co/?igsh=MTQzdWNsbmQ1Mjd5dw%3D%3D"
                  target="_blank"
                  rel="noreferrer"
                  className="t-primary"
                >
                  <i className="bi bi-instagram fs-4"></i>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default ContactUs;
